
import React, { useRef, useEffect, useState } from 'react';

const Testimonials: React.FC = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  const testimonials = [
    {
      quote: "Having worked with other professional coaches, I can confidently say that Alex's approach to personal and professional development has been incredibly valuable and will be something I take with me as a long-term learning experience. Beyond that, his approach in empowering you to identify your own strengths and explore areas where you can improve, is accompanied by in the moment practical exercises.",
      author: "Karla Bonilla",
      position: "Senior Manager, Canadian and Global Partnerships and Projects | Habitat for Humanity Canada"
    },
    {
      quote: "Alex has been a great public speaking coach that provided me with relevant tools to improve my presentation skills. While I regularly lead meetings with multiple stakeholders and I can successfully conduct the sessions, there were still areas that I was looking to improve. Alex enabled me to refine those gaps by achieving higher quality in my content delivery",
      author: "Claudio Lener",
      position: "Product manager | Cisco"
    },
    {
      quote: "I worked with Alex to improve on my meeting presentation skills to become a more confident manager and speaker. Alex is so experienced, engaging and thoughtful. He's helped increase my awareness of how I communicate and where I can progress and improve. Alex tailored our sessions to my specific needs and was very open and adaptable. I would highly recommend his course",
      author: "Andrea Louise NG",
      position: "Digital Fundraising manager | Save the Children"
    },
  ];

  return (
    <section id="testimonials" className="py-20 bg-presintention-light section-padding" ref={sectionRef}>
      <div className="container-width">
        <div className="text-center mb-16">
          <span className={`inline-block px-3 py-1 bg-presintention-accent/10 text-presintention-accent rounded-full text-sm font-medium mb-4 transition-all duration-700 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
            Client Testimonials
          </span>
          <h2 className={`text-3xl md:text-4xl font-bold mb-6 transition-all duration-700 delay-100 text-presintention-dark ${isVisible ? 'opacity-100' : 'opacity-0 translate-y-4'}`}>
            What Our <span className="text-presintention-accent">Clients Say</span>
          </h2>
          <p className={`max-w-2xl mx-auto text-presintention-dark/70 text-lg transition-all duration-700 delay-200 ${isVisible ? 'opacity-100' : 'opacity-0 translate-y-4'}`}>
            Hear from the professionals who have transformed their presentation skills and achieved their goals through our coaching.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mt-12">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index} 
              className={`bg-white p-8 rounded-xl shadow-md border border-presintention-border transition-all duration-700 delay-${300 + (index * 100)} ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
            >
              <div className="flex flex-col h-full">
                <div className="mb-6">
                  <svg className="h-8 w-8 text-presintention-accent mb-2" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                  </svg>
                  <p className="text-presintention-dark italic mb-4">{testimonial.quote}</p>
                </div>
                <div className="mt-auto">
                  <h4 className="font-bold text-presintention-dark">{testimonial.author}</h4>
                  <p className="text-sm text-presintention-dark/70">{testimonial.position}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
